import styled from "@emotion/styled";
import backgroundImg from "./assets/fondo-azul-degradado.webp"

export const AppBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${backgroundImg});
  background-size: cover;
  background-position: center;
  background-color: #0000004D; 
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;
